import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import WatermarkPDFImageListScreen from "./WatermarkPDFImageListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function WatermarkPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Watermark PDF files" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/watermark_pdf", title: "Add watermark to PDF documents" },
    data2: { link: "/watermark_pdf", title: "Copyright PDF files" },
    data3: { link: "/watermark_pdf", title: "PDF watermark tool" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Add watermark to PDF online easily. Insert text or image watermarks to protect documents quickly with our fast and secure PDF watermark tool."
      ></meta>
      <meta
        name="keywords"
        content="watermark pdf, add watermark to pdf, pdf watermark tool, pdf watermark online, insert watermark pdf, text watermark pdf, image watermark pdf, protect pdf documents, pdf editor online, online pdf watermark, add logo to pdf, pdf branding tool, watermark pdf free, secure pdf watermark, pdf document protection, add copyright to pdf, add watermarks to selected pages of pdf file, add watermark logo to pdf, add background image to pdf, add custom text watermark to pdf, add copyright protection to pdf,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <WatermarkPDFImageListScreen
          title={title}
        ></WatermarkPDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Watermark PDF Offline App is a powerful and easy-to-use solution designed to help users add watermark to PDF files with ease, whether you prefer working offline or need features similar to add watermark PDF online tools. This offline PDF watermark app ensures complete privacy and security, as all processing is done directly on your device with no file uploads or data sharing. Whether you want to protect documents, add a logo, brand your files, or mark PDFs as confidential, this PDF watermarking tool delivers fast and reliable performance. Users can customize watermark text or image, font style, size, color, opacity, rotation, and position to create professional-quality watermarked PDFs in just a few taps. Ideal for students, professionals, freelancers, and businesses, this PDF editor maintains original document quality while allowing you to add a watermark to PDF files quickly and securely. With no app-added watermarks, no sign-up required, and full offline functionality, this watermark PDF app is a smart alternative to add watermark PDF online services, giving you complete control anytime, anywhere." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Watermark",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Watermark PDF"
            why_use={[
              {
                title: "Protect Document Ownership",
                description:
                  "Adding a watermark to PDF files helps protect your content from unauthorized use. A PDF watermark clearly shows ownership, making it ideal for copyrighted documents, reports, and digital assets.",
              },
              {
                title: "Enhance Document Security",
                description:
                  "Watermark PDF tools add an extra layer of security by marking files as confidential, draft, or private. This discourages misuse and ensures sensitive information remains protected.",
              },
              {
                title: "Professional Branding",
                description:
                  "Using a PDF watermark allows businesses and professionals to add logos, brand names, or custom text. This improves brand visibility and creates a professional appearance in shared documents.",
              },

              {
                title: "Prevent Unauthorized Sharing",
                description:
                  "When you add a watermark to PDF files, it becomes harder for others to distribute or claim your content as their own, especially for invoices, eBooks, and official documents.",
              },
              {
                title: "Maintain Original File Quality",
                description:
                  "Modern watermark PDF apps let you add watermarks without affecting the original PDF quality, ensuring clarity while keeping file size optimized.",
              },
              {
                title: "Offline and Online Flexibility",
                description:
                  "With watermark PDF offline apps, you can add watermarks without an internet connection, offering more privacy compared to add watermark PDF online tools.",
              },
              {
                title: "Customizable Watermark Options",
                description:
                  "You can customize watermark text, image, font size, color, opacity, rotation, and placement, giving full control over how the watermark appears on your PDF.",
              },
              {
                title: "Ideal for Students and Professionals",
                description:
                  "Students, teachers, freelancers, and businesses use PDF watermarking to label assignments, research papers, contracts, and proposals effectively.",
              },
              {
                title: "Fast and Easy PDF Editing",
                description:
                  "Watermark PDF tools are designed for quick processing, allowing users to add a watermark to PDF files in just a few clicks, saving time and effort.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1615002918}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default WatermarkPDFMain;
